import React from 'react';
import {EzFlashMessage} from '@ezcater/recipe';
import type {FlashMessageTemplateProps} from '@ezcater/flash-messages';

interface Props extends FlashMessageTemplateProps {
  autohideDuration?: number;
}

const FlashMessage = ({dismiss, key, type, message, headline, autohideDuration = 5000}: Props) => (
  <div
    role="alert"
    aria-live={type === 'error' ? 'assertive' : 'polite'}
    data-test={`${type}-flash-messages`}
    key={key}
  >
    <EzFlashMessage
      autohideDuration={autohideDuration}
      autohide={type === 'success'}
      onDismiss={dismiss}
      use={type}
      headline={headline}
    >
      {message}
    </EzFlashMessage>
  </div>
);

export default FlashMessage;
